import { useAdminUpdate } from '@reapitform/hooks'
import { AdminActionTemplate, AdminActionTemplatePayload } from '../types'

/** Updates an action template
 * (`PUT /api/forms/{formRef}/versions/{versionRef}/action-templates/{actionTemplateRef}`). */
export const useUpdateAdminActionTemplate = (
  formReferenceID: string,
  versionReferenceID: string,
  actionTemplateReferenceID: string,
) =>
  useAdminUpdate<AdminActionTemplatePayload, AdminActionTemplate>({
    path: `/api/forms/${formReferenceID}/versions/${versionReferenceID}/action-templates/${actionTemplateReferenceID}`,
    method: 'PUT',
    errorMessage: 'Failed to update the action',
    successMessage: 'Action updated',
  })
